var map = {
	"./alpabern.png": 475,
	"./bruderertrans.png": 476,
	"./daetwiler.png": 477,
	"./datarec.png": 478,
	"./deutschepost.png": 479,
	"./die-entsorger.png": 480,
	"./drisa.png": 481,
	"./eggenberger.png": 482,
	"./entsorgungsfachmarkt.png": 483,
	"./erz.png": 484,
	"./haeusle.png": 485,
	"./huegler.png": 486,
	"./hugelshofer.png": 487,
	"./immark.png": 488,
	"./innoplastics.png": 489,
	"./innorecycling.png": 490,
	"./kaufmann.png": 491,
	"./keller.png": 492,
	"./kva.png": 493,
	"./landolt.png": 494,
	"./lapp.png": 495,
	"./loacker.png": 496,
	"./model.png": 497,
	"./mueller.png": 498,
	"./mz.png": 499,
	"./nes.png": 500,
	"./norline.png": 501,
	"./papirec.png": 502,
	"./peterschmid.png": 503,
	"./solenthaler.png": 504,
	"./spross.png": 505,
	"./swissglas.png": 506,
	"./swissrepair.png": 507,
	"./swissterminal.png": 508,
	"./thuer.png": 509,
	"./toshiba.png": 510
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos ^\.\/.*$
// module id = 474
// module chunks = 1